import { FlaggableIngredient } from 'common/Constants';
import { IngredientsFlaggedChip } from 'src/pages/consumer/meal-plans/components/Chips/IngredientsFlaggedChip';
import Chip, { ChipColor } from 'web-common/src/shared/design-system/components/Chip';
import { Icon, IconColor, IconName } from 'web-common/src/shared/design-system/components/Icon';
import { DietaryTags as DietaryTagsEnum } from 'web-common/src/shared/Enums';

interface DietaryTagsProps {
  dietaryTags: DietaryTagsEnum[];
  ingredientsFlagged?: FlaggableIngredient[];
  customIngredientsFlagged?: string[] | null;
}

// Map DietaryTags to icon name strings from web-common
const dietaryTagToIconName: Record<DietaryTagsEnum, IconName> = {
  [DietaryTagsEnum.VEGETARIAN]: 'dietTypeVegetarian',
  [DietaryTagsEnum.VEGAN]: 'dietTypeVegan',
  [DietaryTagsEnum.GLUTEN_FREE]: 'restrictionGlutenFree',
  [DietaryTagsEnum.DAIRY_FREE]: 'restrictionDairyFree',
  [DietaryTagsEnum.PALEO]: 'dietTypePaleo',
  [DietaryTagsEnum.LOW_FODMAP]: 'lowFodmap',
  [DietaryTagsEnum.WHOLE30]: 'dietTypeWhole30',
  [DietaryTagsEnum.HALAL]: 'dietTypeHalal',
  [DietaryTagsEnum.ORGANIC]: 'organic',
  [DietaryTagsEnum.COMPOSTABLE]: 'leavesCircle',
  [DietaryTagsEnum.KOSHER]: 'kosher',
};

export const DietaryTags: React.FC<DietaryTagsProps> = ({
  dietaryTags,
  ingredientsFlagged,
  customIngredientsFlagged,
}) => {
  const dietaryBadges = dietaryTags.map((tag) => {
    const iconName = dietaryTagToIconName[tag];
    const icon = <Icon name={iconName} color={IconColor.EGGPLANT_500} size={16} />;
    return <Chip key={`dietary-${tag}`} color={ChipColor.RICE} icon={icon} copy={tag} applyFullHeight />;
  });

  const ingredientFlaggedChips = ingredientsFlagged?.map((ingredient) => (
    <IngredientsFlaggedChip
      key={`ingredient-${ingredient}`}
      ingredientsFlagged={[ingredient]}
      showIngredientName={true}
    />
  ));

  const customIngredientFlaggedChips = customIngredientsFlagged?.map((ingredient) => (
    <IngredientsFlaggedChip
      key={`custom-ingredient-${ingredient}`}
      ingredientsFlagged={[]}
      customIngredientsFlagged={[ingredient]}
      showIngredientName={true}
    />
  ));

  return (
    <>
      {ingredientFlaggedChips}
      {customIngredientFlaggedChips}
      {dietaryBadges}
    </>
  );
};
